import React from 'react'
import { Box, Typography } from '@mui/material'

import { dsColorNew } from '@palette'
import PageWrapper from 'Pages/@PageWrapper'
import { ASK_LINE, noAccessCopy } from './@services/access'


/**
 * The screen a user without a feature sees at the feature's address — never a 404 (patterns.md K4; CU-869fcezdm).
 * `name` is the feature as the menu calls it. `replacement` (a node) names where a retired screen lives now; with it
 * the card reads "<name> has moved" (`Pages/BusinessLogistics/@components/MovedNote` is the thin wrapper the two
 * retired screens keep). Imported by path, not from the `@components` barrel: it renders inside `PageWrapper`, which
 * itself reads the barrel.
 */
export default function NoAccess({ name, replacement = null }) {
	const moved = Boolean(replacement)
	const { subtitle, title, intro } = noAccessCopy({ name, moved })

	return <PageWrapper head={`DS Rentacar | ${name}`} title={name} subtitle={subtitle} isEmpty={false}>
		<Box sx={{ maxWidth: 640, mx: 'auto', mt: 6, p: 3, border: `1px solid ${dsColorNew.grayBorder}`, borderRadius: '16px', backgroundColor: dsColorNew.white }}>
			<Typography sx={{ fontSize: 18, fontWeight: 700, color: dsColorNew.textTitle, mb: 1 }}>{title}</Typography>
			<Typography sx={{ fontSize: 14, color: dsColorNew.textDark, lineHeight: 1.6 }}>
				{moved ? <>{intro} {replacement}. {ASK_LINE}</> : <>{intro} {ASK_LINE}</>}
			</Typography>
		</Box>
	</PageWrapper>
}
